import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReportService } from 'app/service/report.service';
import { SelectItem } from 'primeng/primeng';
import { AuthAccessProvider } from '../core/core.auth';
import { BaseComponent, HolidayReport, UserContext } from '../core/core.component';
import { AssenzeService } from '../service/assenze.service';
import { MessageProvider } from '../service/message.service';

import { Headers } from '@angular/http';
import { BusyProvider } from 'app/service/busy.service';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-holidays-report',
  templateUrl: './holidays-report.component.html',
  styleUrls: ['./holidays-report.component.css']
})
export class HolidaysReportComponent extends BaseComponent implements OnInit {

  userContext: UserContext;
  loading = false;
  rows: HolidayReport[] = [];

  years: SelectItem[] = [];
  yearSelected: number = null;

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private reports: ReportService,
    private assenzeService: AssenzeService,
    private busyProvider: BusyProvider,
  ) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
    this.userContext = this.authAccess.getUserContext();
  }

  ngOnInit() {
    this.loading = true;
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.assenzeService.getDistinctYears(this.userContext.srmToken).subscribe(
        result => {
          for (let i = 0; i < result.years.length; ++i) {
            const year = result.years[i];
            this.years.push({label: String(year), value: year});
          }
          this.yearSelected = new Date().getFullYear();
          this.loadHolidayReport();
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  loadHolidayReport() {
    this.loading = true;
    this.assenzeService.getHolidayReport(this.userContext.srmToken, false, this.yearSelected).subscribe(
      result => {
        this.rows = result.results;
        this.loading = false;
      },
      error => {
        this.handleError(error);
      });
  }

  exportReport() {
    this.busyProvider.showBusyIndicator();

    let userIds = this.rows.map(u => u.idUser);
    let params = { userIds: userIds, year: this.yearSelected }

    this.reports.exportReportWithHeaders(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.VacationPlanningReportGenerator', params).subscribe(
      (result) => {
        let headers = result.headers as Headers
        let filename = headers.get('content-disposition').split('filename=')[1]

        let blob = new Blob([result.blob()], { type: headers.get('content-type') });
        this.busyProvider.hideBusyIndicator();
        FileSaver.saveAs(blob, filename);
      },
      error => {
        this.busyProvider.hideBusyIndicator();
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/holidays-report/holidays-report.component.ts